export const a11y = {
    getAriaLiveCharCount: (remaining, max) => `${remaining} out of ${max} characters remaining`,
};
export const visual = {
    appendedText: 'Characters',
};
//# sourceMappingURL=strings.js.map